import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from './services/global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Eukanuba-Portal';

  constructor(
    private _router: Router,
    private _glService: GlobalService
  ) { }

  ngOnInit(): void {
    const expiresOn = localStorage.getItem('expiresOn');
    if (expiresOn && new Date(expiresOn).getTime() <= Date.now()) {
      localStorage.clear();
      this._router.navigateByUrl('/login');
    }

    this._glService.checkIE();
  }
}
